export const PAYMENT_TYPE_CODE = {
    CASH_PAYMENT: '2191',
    CHEQUE_PAYMENT :'2192',
    BANK_DEPOSIT :"2193",
    CARD_PAYMENT:"2194",
    OVER_PAYMENT:"2195",
    RETURN_AMOUNT:"2196",
    ONLINE_TRANSFER:"2197",
    INVOICE_RETURN_CODE : "2199",
    GIFT_VOUCHER_PAYMENT : "21910",
    ROYALTY_POINTS : "21911"

}